import { Component, OnInit } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'app-number-input',
  templateUrl: './number-input.component.html',
  styleUrls: ['./number-input.component.scss']
})
export class NumberInputComponent extends FieldType<FieldTypeConfig> implements OnInit {

  stepValue!: number;
  pattern!: string;

  ngOnInit() {
    // If decimal, calculate the step based on digitsAfterDecimal
    this.stepValue = this.props['decimal'] ? 1 / Math.pow(10, this.props['digitsAfterDecimal']) : 1;

    // Define the pattern for the regex based on whether decimals are allowed
    if (this.props['decimal']) {
      // Regex to allow numbers with up to the defined decimal places (e.g., 2 decimal places)
      this.pattern = `^-?\\d+(\\.\\d{0,${this.props['digitsAfterDecimal']}})?$`;
    } else {
      // Regex to allow only whole numbers
      this.pattern = '^-?\\d+$';
    }
  }
}
